"use client";

import { SWRConfig } from "swr";
import { AnalyticsProvider } from "@/components/providers/analytics-provider";
import { Toaster } from "sonner";

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <SWRConfig
      value={{
        // Don't retry on 4xx client errors (e.g., 404 Not Found)
        onErrorRetry: (error, _key, _config, revalidate, { retryCount }) => {
          // Don't retry on client errors (4xx)
          if (error.status >= 400 && error.status < 500) return;

          // Only retry up to 3 times for other errors
          if (retryCount >= 2) return;

          // Retry after 5 seconds
          setTimeout(() => revalidate({ retryCount }), 1000);
        },
      }}
    >
      <AnalyticsProvider>
        {children}
        <Toaster richColors position="top-right" closeButton />
      </AnalyticsProvider>
    </SWRConfig>
  );
};
